import { useInfiniteQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { marketService } from 'shared/src/api';

interface UseMarketRankingsParams {
  market_type_sno: number;
  category_sno?: number;
  age_list?: number[];
  style_list?: string[];
}

export const useMarketRankings = (params: UseMarketRankingsParams) => {
  return useInfiniteQuery({
    queryKey: queryKey.marketRankings(params),
    queryFn: ({ pageParam }) =>
      marketService.getMarketRankings({
        ...params,
        next_token: pageParam,
      }),
    initialPageParam: null as string | null,
    getNextPageParam: lastPage => lastPage.next_token ?? undefined,
    select: data => ({
      ...data.pages[data.pages.length - 1],
      markets: data.pages.flatMap(page => page.markets),
    }),
  });
};
